import Vue from 'vue'
import Router from 'vue-router'
import home from '../page/home.vue'
import loading from '../page/loading.vue'

Vue.use(Router)

export default new Router({
  mode:'history',
  routes: [
    {
      path: '/home',
      name: 'home',
      component: home
    },
    {
      path: '/loading',
      name: 'loading',
      component: loading
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js